import React from 'react';
import ContentLoader from 'react-content-loader';

export const CVLoader = (props) => (
    <>
        <div className="content-loader">
            <ContentLoader 
                speed={2}
                viewBox="0 0 716 700"
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
                {...props}
            >
                <rect x="0" y="4" rx="5" ry="5" width="100%" height="150" />

                <rect x="0" y="170" rx="5" ry="5" width="37.5%" height="350" /> 
            
                <rect x="40%" y="170" rx="5" ry="5" width="60%" height="500" />
            </ContentLoader>
        </div>

        <div className="content-loader__mobile">
            <ContentLoader 
                speed={2}
                viewBox="0 0 400 1200"
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
                {...props}
            >
                <rect x="0" y="20" rx="5" ry="5" width="100%" height="200" />
                <rect x="0" y="240" rx="5" ry="5" width="100%" height="400" />
                <rect x="0" y="660" rx="5" ry="5" width="100%" height="400" />
            </ContentLoader>
        </div>
    </>
);